import { IMyHomeStatusInfoSchema } from '../../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';
import { EStatusLoad } from '../../types/redux/status';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EStatusActions {
  TOGGLE_STATUS_STATUS = 'TOGGLE_STATUS_STATUS',
  TOGGLE_STATUS_MODAL = 'TOGGLE_STATUS_MODAL',
  SET_STATUS_LIST = 'SET_STATUS_LIST',
  SET_MY_HOME_STATUS = 'SET_MY_HOME_STATUS',
}

export const toggleStatusModal = actionGenerator<EStatusActions.TOGGLE_STATUS_MODAL, boolean>(
  EStatusActions.TOGGLE_STATUS_MODAL,
);
export const toggleStatusLoad = actionGenerator<EStatusActions.TOGGLE_STATUS_STATUS, EStatusLoad>(
  EStatusActions.TOGGLE_STATUS_STATUS,
);
export const setStatusList = actionGenerator<EStatusActions.SET_STATUS_LIST, IMyHomeStatusInfoSchema[]>(
  EStatusActions.SET_STATUS_LIST,
);
export const setMyHomeStatus = actionGenerator<EStatusActions.SET_MY_HOME_STATUS, IMyHomeStatusInfoSchema>(
  EStatusActions.SET_MY_HOME_STATUS,
);

export type TToggleStatusModalAction = ReturnType<typeof toggleStatusModal>;
export type TToggleStatusLoadAction = ReturnType<typeof toggleStatusLoad>;
export type TSetStatusListAction = ReturnType<typeof setStatusList>;
export type TSetMyHomeStatusAction = ReturnType<typeof setMyHomeStatus>;

export type TStatusActions =
  | TToggleStatusModalAction
  | TSetStatusListAction
  | TSetMyHomeStatusAction
  | TToggleStatusLoadAction;
